import { Component, OnInit, OnDestroy } from "@angular/core";
import { GlobalApp, LoadingStatus } from "./tools/global";
import { Subscription } from "rxjs";
import {SettingsService} from "./api/services/settings.service";
import { ConfigService, AlertsService } from "./api/services";
import { AppInfo, AlertModel, UserState } from "./api/models";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  providers: [],
})
export class AppComponent implements OnInit, OnDestroy {
  isFullScreenMode = false;
  showBranding = false;
  loadingStatus: LoadingStatus = {
    isLoading: false,
    loadingMessage: "",
  };
  loadingStatusSubscription: Subscription = null;
  isReportExportSubscription: Subscription = null;
  tosUrl: string = '';
  ppUrl: string = '';

  title = "app";
  currentYear = new Date().getFullYear();
  appInfo: AppInfo = { version: '', environment: '' };

  alertMessages: AlertModel[] = [];
  showAlertMessages: boolean = true;
  expiredSubscriptions: AlertModel[] = [];
  showExpiredSubscriptions: boolean = true;

  userState: UserState = {
    reportOnly: false,
    userManagerOnly: false,
    invoiceManagerOnly: false,
    interactives: [],
    modifiedInteractives: [],
    xmlas: [],
    reportExportState: {},
    isInteractiveUser: false,
    isReportExportUser: false,
    isEmbeddedUser: false,
    hasAiChats: false,
    isValidState: false
  };
  userStateSubscription: Subscription = null;

  constructor(
    public app: GlobalApp,
    private settingsService: SettingsService,
    private configService: ConfigService,
    private alertsService: AlertsService
  ) {}

  ngOnInit() {

    this.app.isShowingBranding.subscribe(result => this.showBranding = result);

    this.userStateSubscription = this.app.userState.subscribe((userState) => {
      this.userState = userState;

      this.expiredSubscriptions = [];

      var hasActiveSubscription = false;

      this.userState.interactives.forEach(interactive => {
        interactive.subscriptionHeaders.forEach(header => {
          var expireDate = Date.parse(header.expireDate);
          if (expireDate < Date.now()) {
            if (!this.expiredSubscriptions.find(x => x.id === header.subscriptionId)) {
              this.expiredSubscriptions.push({
                id: header.subscriptionId,
                active: true,
                message: header.subscriptionName + ' expired on ' + header.expireDate
              });
            }
          } else {
            hasActiveSubscription = true;
          }
        });
      });

      if (hasActiveSubscription) {
        this.expiredSubscriptions = [];
      }
    });

    this.loadingStatusSubscription = this.app.loadingStatus.subscribe(
      (loadingStatus) => {
        this.loadingStatus = loadingStatus;
      }
    );

    this.isReportExportSubscription = this.app.isReportExport.subscribe(
      (isFullScreenMode) => {
        this.isFullScreenMode = isFullScreenMode;
      }
    );

    this.settingsService.settingsGetSetting("TOS").subscribe(resultUrl => {
      this.tosUrl = resultUrl;
    });

    this.settingsService.settingsGetSetting("PP").subscribe(resultUrl => {
      this.ppUrl = resultUrl;
    });

    //Disabling until pre-filter with fabric backend is complete
    //this.preFilterValuesService.cacheValues().then((success) => console.log("Done Cacheing Values"));

    this.alertsService.alertsGetActiveAlertMessages().subscribe(res => {
      this.alertMessages = res;
    });

    this.configService.configGetAppInfo().subscribe(appInfo => {
      this.appInfo = appInfo;
    });
  }

  ngOnDestroy() {
    if (this.loadingStatusSubscription) {
      this.loadingStatusSubscription.unsubscribe();
    }
  }
}
